module.exports = __webpack_public_path__ + "static/media/ilheus-ba.c3ef36aa.jpg";